import { render } from "./AdminShops.vue?vue&type=template&id=8782d6da&scoped=true"
import script from "./AdminShops.vue?vue&type=script&lang=js"
export * from "./AdminShops.vue?vue&type=script&lang=js"

import "./AdminShops.vue?vue&type=style&index=0&id=8782d6da&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8782d6da"]])

export default __exports__